import React from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import { parseAlertDetailTimeline } from '../../../../utils/normalizers/alertDetailTimeline';
import RealTimeline from '../../../molecules/RealTimeline';
import { InnerDataFormater } from '../listFormater';

interface IAlertsCardInnerContent {
  data: InnerDataFormater[];
  index: number;
}

export const AlertsCardInnerContent = ({ index, data }: IAlertsCardInnerContent) => {
  const notification: InnerDataFormater = data[index];

  return (
    <Div>
      <div className='station_details'>
        <p className='strong label1'>{T('Station ID')}</p>
        {notification?.about?.connectorId && <p className='strong label2'>Conector</p>}
        {notification?.about?.errorMessage && <p className='strong label3'>{T('Error')}</p>}
        <p className='value1'>{notification?.about.chargeBoxName}</p>
        <p className='value2'>{notification?.about.connectorId}</p>
        <p className='value3'>{notification?.about.errorMessage}</p>
      </div>
      {notification?.about.type === 'Warning' && (
        <RealTimeline className='realtime' items={parseAlertDetailTimeline(data, notification.about.transactionId)} />
      )}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  .station_details {
    padding-left: 20px;
    margin-top: 20px;
    width: 20%;
    display: grid;
    grid-template-columns: 7em 1fr;

    p {
      margin: 3px 0;
      font-size: 12px;
      width: max-content;
    }

    .strong {
      font-weight: 600;
      grid-column: 1 / 1;
    }

    .label1 {
      grid-row: 1;
      grid-column: 1 / -1;
    }

    .value1 {
      grid-row: 1;
      grid-column: 2;
    }
    .value2 {
      grid-row: 2;
      grid-column: 2;
    }
    .value3 {
      grid-row: 3;
      grid-column: 2;
    }
  }
  .realtime {
    margin-left: 10%;
    background-color: #fff;
    padding: 20px 10px 0 10px;
    height: 100%;
  }
`;
